import { useFlow } from "@Libs/Flow/hooks/useFlow";
import { ServiceRequestFlow } from "../Flows/ServiceRequestFlow";

export const useServiceRequestFlow = () => {
  const { state, backRoute } = useFlow(ServiceRequestFlow);

  return {
    ...state,
    backRoute,
  };
};
